import React from "react";

const CFProgressCircle = (props) => {
  const {
    progress,
    size,
    className = "",
    borderWidth = 2,
    borderColor = "#000",
    fontColor = "#003fff",
    fontSize = "text-3xl",
    indeterminate = false,
    showPercentage = true,
  } = props;

  const isLoading = indeterminate || progress === undefined || progress === null;
  const displayProgress = isLoading ? 70 : Math.min(100, Math.max(0, progress));

  return (
    <div
      role="progressbar"
      aria-valuenow={isLoading ? undefined : displayProgress}
      aria-valuemin={0}
      aria-valuemax={100}
      className={`cf-progress-circle relative flex items-center justify-center ml-auto mr-auto ${className}`}
      style={{
        width: size || '100%',
        animation: isLoading ? 'cf-progress-spinner 1s linear infinite' : 'none'
      }}
    >
      <svg
        className="size-full -rotate-90"
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          className="stroke-current text-gray-200 dark:text-neutral-700"
          strokeWidth={borderWidth}
        />
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          className={`transition-all duration-500 stroke-current`}
          style={{ color: borderColor }}
          strokeWidth={borderWidth}
          strokeDasharray="100"
          strokeDashoffset={100 - displayProgress}
          strokeLinecap="round"
        />
      </svg>

      {!isLoading && showPercentage && (
        <div className="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
          <span className={`text-center ${fontSize} font-bold`} style={{ color: fontColor }}>
            {Math.round(displayProgress)}%
          </span>
        </div>
      )}

      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    </div>
  );
};

const stylesheet = `
  @keyframes cf-progress-spinner {
    100% { transform: rotate(360deg); }
  }
`;

export default CFProgressCircle;
